import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Sunrise"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 19.5H22.4985V21H1.5V19.5ZM12 15C13.656 15.0021 14.9979 16.344 15 18H16.5C16.5 15.5147 14.4853 13.5 12 13.5C9.51472 13.5 7.5 15.5147 7.5 18H9C9.00207 16.344 10.344 15.0021 12 15ZM18.75 16.5H22.5V18H18.75V16.5ZM16.2654 12.675L18.8949 10.0447L19.9554 11.1052L17.3259 13.7347L16.2654 12.675ZM12 3L8.25 6.75L9.3075 7.8075L11.25 5.8725V11.25H12.75V5.8725L14.6925 7.8075L15.75 6.75L12 3ZM4.04486 11.1052L5.10536 10.0447L7.73486 12.6742L6.67511 13.7347L4.04486 11.1052ZM1.5 16.5H5.25V18H1.5V16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Sunrise.vue"]]);
